import axios from "axios";
import * as actionType from "../../../constant/actionType";

export const CustomReports =
  (APIData) => async (dispatch) => {
    try {
      const response = await axios({
        method: "post",
        data: APIData,
        headers: {
          Authorization: `Bearer ${localStorage.getItem("conserve_authtoken")}`,
        },
        url: `${actionType.environment_url}/api/admin/HandleCustomReports`,
      });
      return response.data;
    } catch (error) {
      return error.message;
    }
  };


  export const FetchAllCustomReports = (apidata) => async (dispatch) => {
    /*** API Call Action ***/
    try {
      const response = await axios({
        method: "get",
        headers: {
          Authorization: `Bearer ${localStorage.getItem("conserve_authtoken")}`,
        },
        url: `${actionType.environment_url}/api/admin/GetAllCustomReports`,
        params: apidata, 
      });
  
      return response.data;  
    } catch (error) {
      console.error("Error in GetAllfavouriteReports:", error);  
      return { error: error.message };  
    }
  };